import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import { getModel, getViewer, utils as macheteUtils } from 'src/machete-redux';
import MeasureNumber from 'src/components/MeasureSidebar/MeasureNumber';
import constants from 'src/constants';
import { Container, Letter, Area } from './styled';

const { UNITS } = constants.measure;
const { OUTLINE_OPTS, FOCUS_OPTS } = constants.machete;

export default class MainMaterialItem extends PureComponent {
  static propTypes = {
    letter: PropTypes.string.isRequired,
    area: PropTypes.number.isRequired,
    uuid: PropTypes.string.isRequired,
  };

  @autobind
  outlineAndFocusOnFacade() {
    const {
      addOutlineToElement,
      addTextToFacade,
      removeTextFromElement,
    } = macheteUtils;

    getModel().facades.forEach((facade) => {
      if (facade.uuid === this.props.uuid) {
        getViewer().focus(facade, FOCUS_OPTS.getDefault());
        addOutlineToElement(facade, OUTLINE_OPTS.getFocused());
        addTextToFacade(facade);
      } else {
        addOutlineToElement(facade, OUTLINE_OPTS.getDefault());
        removeTextFromElement(facade);
      }
    });
  }

  render() {
    const { letter, area } = this.props;
    return (
      <Container onClick={this.outlineAndFocusOnFacade}>
        <Letter data-selenium="mainMaterialNameText">{letter}</Letter>
        <Area>
          <MeasureNumber
            number={area}
            isSquare
            unit={UNITS.feet.abbreviation}
          />
        </Area>
      </Container>
    );
  }
}
